import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router';

import { getPathWithoutLocalisation } from 'src/app/utils/getPathWithoutLocalisation';
import { dispatchPageId } from 'src/app/v1/state/dispatcher/pageId';

export const usePageId = (isPageLoading?: boolean) => {
  const dispatch = useDispatch();
  const { pathname } = useLocation();

  useEffect(() => {
    if (pathname && !isPageLoading) {
      const unlocalisedPath = getPathWithoutLocalisation(pathname);
      dispatchPageId(dispatch, unlocalisedPath || pathname);
    }
  }, [dispatch, isPageLoading, pathname]);
};
